import React from 'react';
import c from 'classnames';

import { SearchFacets } from '@uncinc/react-searchkit';
import type { SearchFacetsProps } from '@uncinc/react-searchkit/dist/components/Facets';

import './style.scss';

import SearchFacetRefinementExpandedCheckboxes from './ExpandedCheckboxes';

const SearchVacanciesFilters: React.FC<SearchFacetsProps> = (props) => {
  const { className, ...restProps } = props;

  const classNames = c('SearchVacancies__Filters', className);

  return (
    <SearchFacets {...restProps} className={classNames}>
      <SearchFacetRefinementExpandedCheckboxes
        key="website_filter"
        attribute="website_filter"
        sortBy={['name:asc']}
      />
    </SearchFacets>
  );
};

export default SearchVacanciesFilters;
